import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Step } from 'semantic-ui-react';

const WizardStepDescription = ({ entity, index, steps }) => (
  <Step.Description className="aridhia-wizard-step-description">
    <FormattedMessage id={`${entity}.breadcrumb.${steps[index]}`} />
  </Step.Description>
);

export default WizardStepDescription;
